import Head from "next/head";

import appConfigs from "@/configs";

export interface MetaProps {
  title?: string;
}

export function Meta({ title = appConfigs.appTitle }: MetaProps) {
  return (
    <Head>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-title" content={appConfigs.appTitle} />
      <link rel="icon" href="/favicon.ico" />
      <meta name="robots" content="noindex" />
      <meta httpEquiv="cache-control" content="no-cache" />
      <meta httpEquiv="expires" content="0" />
      <meta httpEquiv="pragma" content="no-cache" />
      <title>{title}</title>
    </Head>
  );
}
